// ** React Imports
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

// ** Custom Components
import Avatar from '@components/avatar'

// ** Utils
import { isUserLoggedIn } from '@utils'

// ** Store & Actions
import { useDispatch } from 'react-redux'
import { handleLogout } from '@store/actions/auth'

// ** Third Party Components
import {
  UncontrolledDropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem
} from 'reactstrap'
import {
  User,
  Mail,
  CheckSquare,
  MessageSquare,
  Settings,
  CreditCard,
  HelpCircle,
  LogOut,
  ChevronDown,
  Award
} from 'react-feather'

// ** Default Avatar Image
import defaultAvatar from '@src/assets/images/portrait/small/avatar-s-11.jpg'
import { usePostHog } from 'posthog-js/react'

const UserDropdown = () => {
  const posthog = usePostHog()
  const dispatch = useDispatch()

  // ** State
  const [userData, setUserData] = useState(null)

  //** ComponentDidMount
  useEffect(() => {
    if (isUserLoggedIn() !== null) {
      setUserData(JSON.parse(localStorage.getItem('userData')))
    }
  }, [])

  //** Vars
  const userAvatar =
    userData && userData.avatar_urls && userData.avatar_urls['48']

  return (
    <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
      <DropdownToggle
        href="/"
        tag="a"
        className="nav-link dropdown-user-link"
        onClick={(e) => e.preventDefault()}
      >
        {userData ? (
          <>
            <Avatar
              img="https://secure.gravatar.com/avatar/b6b9faa2aed04ea8480ab027d5b5f6a6?s=48&amp;d=mm&amp;r=g"
              imgHeight="40"
              imgWidth="40"
              className="mr-75"
            />
            <div className="user-nav d-sm-flex d-none tw-max-w-32">
              <small className="mb-25">Bem-vindo(a)</small>
              <span
                title={(userData && userData['name']) || ''}
                className="user-name mb-0 font-weight-bold tw-text-ellipsis tw-overflow-hidden tw-whitespace-nowrap"
              >
                {/* {(userData && userData["username"]) || "user"} */}
                {(userData && userData['name']) || ''}
              </span>
              {/* <span className="user-status">
                {(userData && userData.role) || 'Admin'}
              </span> */}
            </div>
            <ChevronDown size={15} />
          </>
        ) : (
          <LogOut />
        )}
      </DropdownToggle>
      <DropdownMenu right>
        <DropdownItem tag={Link} to="/brands/account">
          <User size={14} className="mr-75" />
          <span className="align-middle">Minha conta</span>
        </DropdownItem>
        <DropdownItem tag={Link} to="/brands/subscription">
          <Award size={14} className="mr-75" />
          <span className="align-middle">Assinatura</span>
        </DropdownItem>
        {/*
        <DropdownItem tag={Link} to='/apps/email'>
          <Mail size={14} className='mr-75' />
          <span className='align-middle'>Caixa de entrada</span>
        </DropdownItem>
        <DropdownItem tag={Link} to='/apps/todo'>
          <CheckSquare size={14} className='mr-75' />
          <span className='align-middle'>Tarefas</span>
        </DropdownItem>
        <DropdownItem tag={Link} to='/apps/chat'>
          <MessageSquare size={14} className='mr-75' />
          <span className='align-middle'>Chat</span>
        </DropdownItem>
        <DropdownItem divider />

        <DropdownItem tag={Link} to='/pages/pricing'>
          <CreditCard size={14} className='mr-75' />
          <span className='align-middle'>Precificações</span>
        </DropdownItem>
        <DropdownItem tag={Link} to='/pages/faq'>
          <HelpCircle size={14} className='mr-75' />
          <span className='align-middle'>FAQ</span>
        </DropdownItem> */}
        {/* <DropdownItem tag={Link} to="/brands/conta">
          <Settings size={14} className="mr-75" />
          <span className="align-middle">Conta</span>
        </DropdownItem> */}
        <DropdownItem
          tag={Link}
          to="/login"
          onClick={() => {
            dispatch(handleLogout())
            /** @see https://posthog.com/docs/product-analytics/identify#3-reset-after-logout */
            posthog.reset()
          }}
        >
          <LogOut size={14} className="mr-75" />
          <span className="align-middle">Sair</span>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

export default UserDropdown
